export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11 12a1 1 0 011 1v7a1 1 0 01-1 1H4a1 1 0 01-1-1v-7a1 1 0 011-1h7zm-6 7h5v-5H5v5z\" fill=\"#7B61FF\"/><path d=\"M21 20a1 1 0 01-1 1h-5v-2h4v-4h2v5zM15.5 12a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM10.5 7a1.5 1.5 0 110 3 1.5 1.5 0 010-3z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 3a1 1 0 011 1v5a1 1 0 01-1 1h-5a1 1 0 01-1-1V4a1 1 0 011-1h5zm-4 5h3V5h-3v3z\" fill=\"#7B61FF\"/><path d=\"M9 5H5v4H3V4a1 1 0 011-1h5v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};